import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Sticky from 'react-sticky-el';
import {fetchShipping} from '../../../actions/shippingPage';
import {AddressList} from './AddressList';
import {GroupedShippingMethods} from './GroupedShippingMethods';
import {PaymentList} from './PaymentList';
import './Shipping.scss';
import {Summary} from './Summary';

export const ShippingPage = ({cartId}) => {
  const dispatch = useDispatch();

  const {payload, loading, error} = useSelector(
    state => ({
      payload: state.shippingReducer.payload,
      loading: state.shippingReducer.loading,
      error: state.shippingReducer.error,
    }),
  );

  useEffect(() => {
    dispatch(fetchShipping(null, null, null));
  }, [dispatch]);

  let content = <></>;
  if (loading) {
    content = <div className="loader-container">
      <div className="loader"/>
    </div>;
  } else if (error !== null && error !== undefined) {
    content =
      <div className="bootstrap"><p
        className="text-danger">{window.trans('front.order.checkout.shipping_step.error.internal', {
        '{{ cart_id }}': cartId
      })}</p></div>
  } else {
    content =
      <GroupedShippingMethods totalShippingByLabel={payload.summary ? payload.summary.totalShippingByLabel : null}
                              shippingFees={payload.shippingFees} shippingMethods={payload.shippingMethods}/>;
  }

  const isSticky = isSummaryPanelSticky();

  return (
    <div className="row">
      <div id="contents">
        <div className="box wysiwyg">
          <PageTitle/>

          <div className="row fix-spacing">
            <div className="medium-8 columns">
              {content}
            </div>

            <div className="medium-4 columns">
              <Sticky boundaryElement="#contents" disabled={!isSticky}>
                <div className={isSticky ? null : 'sticky'}>
                  <Summary data={payload.summary || []} validateShippingStepUrl={payload.validateShippingStepUrl}/>
                  <AddressList cartId={cartId} billingAddresses={payload.billingAddresses || []}/>
                  <PaymentList payments={payload.paymentList || []} sitePrefix={payload.sitePrefix || ''}/>
                </div>
              </Sticky>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const PageTitle = () => {
  const dispatch = useDispatch();

  const strategies = [];

  const onClick = (strategy) => {
    dispatch(fetchShipping(
      {}, // Reset shipping methods selected
      {}, // Reset withdrawal points selected
      strategy // Let the algorithm select the best shipping methods based on the strategy
    ));
  };

  return (
    <div className="row shipping-method-header">
      <div className="medium-8 columns">
        <h2 className="title-medium black">
          {window.trans("front.order.checkout.shipping_step.index.title")}
        </h2>
        <p dangerouslySetInnerHTML={{
          __html: window.trans('front.order.checkout.shipping_step.header')
        }}></p>
        <div className="form">
          <ul className="shipping-method-header-choice">
            {strategies.map((strategy, index) => {
              return <li key={index}>
                <div className="radio-pair-wrapper radio-pair-wrapper__selected">
                  <div className="radio-pair">
                    <input type="radio" id={strategy.type}
                           defaultValue={strategy.type}
                           onClick={() => onClick(strategy.type)}
                           disabled={strategy.disabled}
                           defaultChecked={strategy.checked}
                           readOnly={strategy.checked}
                    />
                    <label htmlFor={strategy.type}>
                      <p><strong>{strategy.label}</strong></p>
                    </label>
                  </div>
                </div>
              </li>
            })}
          </ul>
        </div>
      </div>
    </div>
  );
}


function isSummaryPanelSticky() {
  const summaryPanel = document.querySelector('.sticky');
  let rightPanelSticky = true;
  if (summaryPanel !== null) {
    rightPanelSticky = summaryPanel.getBoundingClientRect().left > 100;
  }

  return rightPanelSticky;
}
